<template>
  <svg viewBox="2 2 46 46" fill="none" aria-hidden="true">
    <defs>
      <mask id="cursor-mask">
        <rect x="0" y="0" width="48" height="48" fill="white" />
        <path fill="black" d="m6.97 14 17 10 .028 20L40.97 14z" />
      </mask>
    </defs>
    <path fill="currentColor" mask="url(#cursor-mask)" d="M23.974 4 6.97 14v20l17.028 10L40.97 34V14z" />
  </svg>
</template>
